import {
  SET_BRG_DISCHARGED_PATIENTS,
  SET_EMAIL_PROMPT,
  SET_EMAIL_PROMPT_ONLY,
  SET_GENERATED_EMAIL,
  SET_FILTERED_EMAIL,
  SET_PT_SUMM_PROMPT,
  SET_PT_SUMM_PROMPT_ONLY,
  SET_PROMPT,
  SET_BRG_PATIENT_EMAIL_LOGS
} from './types';
import { SetRegValueHelper, SpreadOps } from '../helper';

const initialState = {
  brgDischargedPatients: {
    list: [],
    count: 0,
  },

  emailLog: {
    list: [],
    count: 0,
  },

  generatedEmails: {}, //key is patient id
  filteredEmails: {}, //key is patient id

  emailPrompt: null,
  patientSummaryPrompt: null,
  emailFilterPrompt: null,
};

var temp = "";
initialState.values = SpreadOps({ ...initialState.default });

export default function (state = initialState, action) {
  switch (action.type) {

    case SET_BRG_PATIENT_EMAIL_LOGS:
      return {
        ...state,
        emailLog: {
          list: action.data.list,
          count: action.data.count,
        }
      }

    case SET_BRG_DISCHARGED_PATIENTS:
      return {
        ...state,
        brgDischargedPatients: {
          list: action.data.list,
          count: action.data.count,
        }
      }

    case SET_EMAIL_PROMPT:
      return {
        ...state,
        emailPrompt: action.data
      }

    case SET_EMAIL_PROMPT_ONLY:
      return {
        ...state,
        emailPrompt: {
          ...state.emailPrompt,
          text: action.data
        }
      }

    case SET_PT_SUMM_PROMPT:
      return {
        ...state,
        patientSummaryPrompt: action.data
      }

    case SET_PT_SUMM_PROMPT_ONLY:
      return {
        ...state,
        patientSummaryPrompt: {
          ...state.patientSummaryPrompt,
          text: action.data
        }
      }

    case SET_GENERATED_EMAIL:
      return {
        ...state,
        generatedEmails: action.data
      }

    case SET_FILTERED_EMAIL:
      return {
        ...state,
        filteredEmails: action.data
      }

    case SET_PROMPT:
      return {
        ...state,
        [action.data.key || action.data.name]: action.data.prompt,
      }

    default:
      return state

  }
}
